(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/routers/router_desktop.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/routers/router_desktop.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  var SportinfoPathNames = svs.components.sportinfo.common.constants.SportinfoPathNames;

  svs.matchen.Router = svs.matchen.RouterBase.extend({
    onAfterStartPageInitialized: function(startPageHandler) {
      if (svs.matchen.app.skeleton.getRegion('leftRegion')) {
        svs.matchen.app.skeleton.getRegion('leftRegion').empty();
      }
      if (svs.matchen.app.skeleton.getRegion('rightRegion')) {
        svs.matchen.app.skeleton.getRegion('rightRegion').empty();
      }
      svs.matchen.app.skeleton.addRegionStartPage(new svs.app.productStartPage.ProductStartPage(startPageHandler.getStartPageOptions()));
      $('#right-side').removeAttr('style');
    },

    draw: function(drawId) {
      svs.sport.sport_common.checkExclusionOnVertical();

      svs.matchen.collections.draws = new svs.matchen.collections.Draws(
        svs.matchen.data.draws,
        { parse: true }
      );
      if (svs.components.contextualMenu) {
        svs.components.contextualMenu.makeVisible();
      }

      svs.matchen.app.skeleton.getRegion('regionStartPage').empty();

      var draw = _.findWhere(svs.matchen.data.draws, {
        drawNumber: Number(drawId)
      });

      if (draw) {
        draw = new svs.matchen.models.Draw(draw, { parse: true });
        svs.matchen.views.drawDetail = new svs.matchen.views.DrawDetail({
          model: new svs.matchen.models.Coupon({}, { draw: draw })
        });
        svs.matchen.app.skeleton.addLeftRegion(svs.matchen.views.drawDetail);
        this.bigStat = new svs.matchen.BigStat();
        var cleanedUpPathname = Backbone.history.location.pathname.replace(new RegExp('/' + Object.values(SportinfoPathNames).join('|') + '$', 'i'), '');
        var pathname = cleanedUpPathname;
        var matchId = draw.get('match').matchId;

        var bigStatOptions = {
          productId: draw.get('productId'),
          drawNumber: draw.get('drawNumber'),
          matchId: matchId,
          tab: svs.matchen.data.params.tab,
          domElement: '#right-side',
          modulePath: pathname
        };
        this.bigStat.openBigStat(bigStatOptions);
      } else {
        svs.sport.sport_common.showErrorDialog('Den aktuella omgången kunde inte visas');
        Backbone.history.navigate('', { trigger: true, replace: true });
      }
    }
  });
})(Backbone, _, svs);


 })(window);